// const mutations = {
//   updateResult(state, payload) {
//     state.resultData[payload.key] = payload.value
//   }
// }

const getters = {
    getIdNumber(state) {
      return state.persisted.identificationNumber
    },
    getShowConfirmation(state) {
      return state.persisted.showConfirmation
    },
    getConfirmationType(state) {
      return state.persisted.confirmationType
    },
    getOrderComplete(state) {
      return state.persisted.orderIsComplete
    },
    getFullName(state) {
      return state.persisted.givenName + " " + state.persisted.familyName
    },
    getGivenName(state) {
      return state.persisted.givenName
    },
    getFamilyName(state) {
      return state.persisted.familyName 
    }, 
    getEmail(state) {
      return state.persisted.email 
    }, 
    getPhone(state) {
      return state.persisted.phone 
    }, 
    getProduct(state) {
      return state.persisted.product
    },
    getFinalFormData(state) {
      return state.persisted.finalFormData
    },
    getIdentificationNumber(state) {
      return state.persisted.identificationNumber
    },
    getCert(state) {
      return state.persisted.cert
    },
    getSignature(state) {
      return state.persisted.signature
    },
    getOcspResponse(state) {
      return state.persisted.ocspResponse
    },
    getPreferredContact(state) {
      return state.persisted.preferredContact
    }
}

const state = {
  persisted: {
      identificationNumber: '',
      finalFormData: '',
      verificationData: '',
      showConfirmation: false,
      confirmationType: '',
      givenName: '',
      familyName: '',
      product: '',
      cert: '',
      signature: '',
      ocspResponse: '',
      orderIsComplete: '',
      email: '',
      phone: '',
      preferredContact: '',
  }
}

const mutations = {
    setIdentificationNumber( state, { identificationNumber } ) {
      state.persisted.identificationNumber = identificationNumber
    },
    setName( state, { givenName, familyName } ) {
      state.persisted.givenName = givenName
      state.persisted.familyName = familyName
    },
    setFamilyName( state, { familyName } ) {
      state.persisted.fullName = familyName
    },
    setProduct( state, { product } ) {
      state.persisted.product = product
    },
    setVerificationData( state, { cert, signature, ocspResponse } ) {
      state.persisted.cert = cert
      state.persisted.signature = signature
      state.persisted.ocspResponse = ocspResponse
    },
    setFinalFormData( state, { finalFormData } ) {
      state.persisted.finalFormData = finalFormData
    },
    setShowConfirmation( state, { showConfirmation } ) {
      state.persisted.showConfirmation = showConfirmation
    },
    setConfirmationType( state, { confirmationType } ) {
      state.persisted.confirmationType = confirmationType
    },
    setOrderComplete( state, { orderIsComplete } ) {
      state.persisted.orderIsComplete = orderIsComplete
    },
    setEmail( state, { email } ) {
      state.persisted.email = email
    },
    setPhone( state, { phone } ) {
      state.persisted.phone = phone
    },
    setPreferredContact( state, { preferredContact } ) {
      state.persisted.preferredContact = preferredContact
    },
  };

export default {
  namespaced: true,
  mutations,
  getters,
  state
}
